module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    attrs: {
      "width": "300"
    }
  }, [_c('v-card-title', {
    staticClass: "overline py-1 grey lighten-4 overline"
  }, [_vm._v("\n    " + _vm._s(_vm.title) + "\n    "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": "",
      "small": ""
    },
    on: {
      "click": function($event) {
        return _vm.$emit("close")
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-text', [(_vm.practitionerIds.length > 0) ? [_c('v-subheader', {
    staticClass: "overline pl-0"
  }, [_vm._v("Practitioner")]), _vm._v(" "), _vm._l((this.facets.practitioner_id), function(count, practitionerId) {
    return _c('v-checkbox', {
      key: practitionerId,
      staticClass: "ma-0 pa-0 caption",
      attrs: {
        "dense": "",
        "hide-messages": "",
        "value": practitionerId,
        "label": _vm.getPractitionerLabel(practitionerId, count)
      },
      model: {
        value: (_vm.selectedPractitioners),
        callback: function($$v) {
          _vm.selectedPractitioners = $$v
        },
        expression: "selectedPractitioners"
      }
    })
  })] : _vm._e(), _vm._v(" "), _vm._t("default")], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-30072818","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/invoice/InvoiceFilter.vue
// module id = 1377
// module chunks = 9